import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Button } from "@speedoc/design-assets";
import useAppDownloadLink from "../../hooks/useAppDownloadLink";
import { GlobalStore } from "../../stores/global";

const Navbar = () => {
  const downloadLink = useAppDownloadLink();
  const countryCode = GlobalStore.useState(s => s.currentCountryCode);

  return (
    <div id="navbar" className={"desktop mastercard"}>
      <div className="content">
        <nav>
          <div className="logo">
            <Link to="/">
              <img alt="Main logo" src="https://public.speedoc.com/strapi/thumbnail_Speedoc_Logo_77e1b69ea2.png" />
            </Link>
          </div>
          <div className="navCountry">
            <Link className={countryCode === "SG" ? "active" : ""} to="/sg/mastercard">
              Singapore
            </Link>
            <Link className={countryCode === "MY" ? "active" : ""} to="/my/mastercard">
              Malaysia
            </Link>
          </div>
          <img
            className="mastercardLogo"
            src="https://public.speedoc.com/strapi/mc_symbol_d86c09510f.svg"
            alt="Speedoc Mastercard"
          />
        </nav>
        <div className="right">
          <a href={downloadLink}>
            <Button type="button" className="dark sm">
              <span>Get the App</span>
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default withRouter(Navbar);
